// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class DivisionFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    try {
      const region = this.view.state.selectedRegion.id;
      const office = this.view.state.selectedOffice.id;
      const name = this.view.state.name;
      const description = this.view.state.description;
      // console.warn("OFFICE: ", office);
      if (region === undefined) {
        throw new Error("Select OCOM");
      } else if (office === "") {
        throw new Error("Select Location");
      }
      this.change.region = region;
      this.change.office = office;
      this.change.name = name;
      this.change.description = description;
      this.change.status = "active";
      // console.warn("DD: ", this.change);
      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Success");
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default DivisionFormPresenter;
